module.exports = __webpack_public_path__ + "fonts/TencentSans-W7.880f4fdc.ttf";